/** @jsx h */

import { h, render, Component } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../styles.scss';
import IconClose from '../IconClose';

class TopPositionBar extends Component {
    render() {
        const { compareURL, handleCloseComparison, translationsMap, skusCount } = this.props;
        const topPositionBarClasses = classNames({
            [styles.comparisonContent]: true,
        });
        const comparisonLink = classNames({
            [styles.comparisonLink]: true,
            'analytics-compare-now': true,
        });
        const comparisonCloseClasses = classNames({
            [styles.comparisonCloseIcon]: true,
            'analytics-compare-close': true,
        });

        return (
            <div className={topPositionBarClasses}>
                <div className={styles.comparisonInfo}>
                    <div className={styles.comparisonCount}>
                        <span className={styles.productLabel}>
                            {`${translationsMap['apc.comparison.item_was_added']} `}
                        </span>
                        <a
                            href={compareURL}
                            className={comparisonLink}
                            data-compare-count={skusCount}
                        >
                            {translationsMap['apc.comparison.compare_now']}
                        </a>
                    </div>
                </div>
                <div className={styles.comparisonActions}>
                    <span className={comparisonCloseClasses} onClick={handleCloseComparison}>
                        <IconClose />
                    </span>
                </div>
            </div>
        );
    }
}

TopPositionBar.propTypes = {
    compareURL: PropTypes.string.isRequired,
    handleCloseComparison: PropTypes.func.isRequired,
    translationsMap: PropTypes.object.isRequired,
    skusCount: PropTypes.number,
};

TopPositionBar.defaultProps = {
    handleCloseComparison: () => {},
    translationsMap: {
        'apc.comparison.clear_list': 'Clear List',
        'apc.comparison.compare_now': 'Compare Now',
        'apc.comparison.products_to_compare': 'Products to compare',
        'apc.comparison.item_was_added': 'Item was added to comparison',
    },
};

export default TopPositionBar;
